import { Component } from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../../shared/message.service';
import { TopicService } from '../topic.service';
import { NumberCardsService } from '../number-cards.service';

@Component({
  selector: 'app-discover',
  templateUrl: './discover.component.html',
  styleUrls: ['./discover.component.css']
})
export class DiscoverComponent extends GeneralExerciseComponent {

  public hints: any[];
  private representation: string;
  private representationSpec: string;
  public requested: number[];
  public hintCount: number = 0;
  public given: string[] = [];
  public myNotes: string[] = [];
  notesStart: number;
  notesEnd: number;
  numberLines: number;

  constructor(protected activatedRoute: ActivatedRoute, protected topicService: TopicService, protected messageService: MessageService, protected numberCardService: NumberCardsService) {
    super(activatedRoute, topicService, messageService);
  }

  setTypeSpecificsFromConfiguration() {
    this.representation = this.configuration.typespecifics.representation;
    this.representationSpec = this.configuration.typespecifics.representationSpec;

    let hintNumbers =this.configuration.typespecifics.hints;
    this.hints = [];
    for(let set of hintNumbers){
      let array = [];
      for(let value of set){
        array.push({
          value: value, 
          representation: this.numberCardService.getRepresentation(value, this.representation, this.representationSpec)
        })
      }
      this.hints.push(array);
    }
    this.requested = this.configuration.typespecifics.requested;
    this.notesStart = this.configuration.typespecifics.notesStart;
    this.notesEnd = this.configuration.typespecifics.notesEnd;
    this.numberLines = Math.ceil((this.notesEnd-this.notesStart)/2);
    this.hintCount = 0;
    this.given = [];
    this.myNotes = [];
  }

  setTypeSpecificsFromState() {
    if (this.state.typespecific.hintCount != undefined) {
      this.hintCount = this.state.typespecific.hintCount;
    }
    if (this.state.typespecific.given != undefined) {
      this.given = this.state.typespecific.given;
    }
    if (this.state.typespecific.myNotes != undefined) {
      this.myNotes = this.state.typespecific.myNotes;
    }
    if (this.state.solved != undefined) {
      this.solved = this.state.solved;
    }
  }

  computeState() {
    this.state.solved = this.solved;
    this.state.typespecific.hintCount = this.hintCount;
    this.state.typespecific.given = this.given;
    this.state.typespecific.myNotes = this.myNotes;
  }

  checkSolution() {
    let globalError = false;
    for (let index in this.requested) {
      let error = false;
      if (this.given[index] == undefined || this.given[index] == "") {
        this.messageService.addAlertWithTimeout(this.requested[index].toString().concat(" : ", this.get("missingValue")), "danger", 2000);
        error = true;
      } else if (this.given[index].replace("/ /gi", "").toLowerCase() != this.numberCardService.getRepresentation(this.requested[index], this.representation, this.representationSpec).toLowerCase()) {
        this.messageService.addAlertWithTimeout(this.requested[index].toString().concat(":", this.get("wrongAnswer")), "danger", 2000);
        error = true;
      }
      if (!error) {
        this.messageService.addAlertWithTimeout(this.requested[index].toString().concat(" : ", this.get("correct")), "success", 2000);
      } else {
        globalError = true;
      }
    }
    if (!globalError) {
      this.solved = true;
      this.saveState();
    }
  }

  addTipp() {
    this.hintCount++;
  }


  /** evaluates the current state of the exercise 
    * @returns {number} - returns the total number of points (unweigthed, the maximum is 1)
   */
  evaluate(): number[] {
    let result = 0;
    let r = this.requested.length;
    for (let index in this.requested) {
      let error = false;
      if (this.given[index] == undefined || this.given[index] == "") {
        error = true;
      } else if (this.given[index].replace("/ /gi", "").toLowerCase() != this.numberCardService.getRepresentation(this.requested[index], this.representation, this.representationSpec).toLowerCase()) {
        error = true;
      }
      if (!error) {
        result++;
      }
    }
    return [result / r,1];
  }

}
